<template>

  <v-dialog
    v-model="show"
    persistent
    max-width="600">
    <v-card>
        <v-toolbar class="mid-font" color="primary" dense dark >
            <v-icon left >mdi-account</v-icon><span class="va-underline">{{state=='new'?'Register':'Edit'}} Breeder</span>
            <v-spacer/>
            <v-icon  @click="emitToParent('close')">mdi-close</v-icon>
          </v-toolbar>
        <v-card-text>
             <v-form
                ref="form"
                class="mt-4"
                v-model="valid"
                lazy-validation
              >
              <v-row>
                <v-col cols="12">
                  
               <v-text-field
                 v-model="breeder.name"
                  label="Farm Name *"
                  outlined
                  dense
                  :rules="textRules"
                required
                ></v-text-field>

                <v-text-field
                 outlined
                  dense
                 v-model="meta.owner"
                  label="Owner"
                  :rules="textRules"
                required
                ></v-text-field>   
                 <v-text-field
                 outlined
                  dense
                 v-model="meta.address"
                  label="Address"
                ></v-text-field>  

                 <v-text-field
                 outlined
                  dense
                 v-model="meta.contact_no"
                  label="Contact No."
                ></v-text-field>                      
                  
                  <v-autocomplete
                  v-model="breeder.status"
                   :rules="textRules"
                required
                  :items="['Active','Banned']"
                  outlined
                    dense
                  label="Status"
                  ></v-autocomplete>     
                
                </v-col>
              
              </v-row>
             </v-form>
        </v-card-text>
        <v-card-actions>
                <v-btn color="warning" small rounded text @click="emitToParent('close')">CLOSE</v-btn>
            <v-spacer></v-spacer>
            <v-btn  small color="success"  depressed  @click="validate()">{{BTN_TEXT}}</v-btn>
        </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
        type: Boolean,
        default: false
    },
    breeder_id: {
        type: Number,
        default:null
    },
    state: {
        type: String,
        default: "new"
    }
  },
  data: () => ({
      valid: true,
      newpassword:'',
      breeder:{},
      meta:{},
      show1: false,
      textRules: [
        v => !!v || 'Field is required'
      ],
  }),
  computed: {
      BTN_TEXT() {
          if(this.state == 'new')
            return "ADD"
         else 
            return "SAVE"
      }
  },
  watch: {
    show (v) {
      if(v) {
         if (this.state != 'new') {
          this.getBreeder()
        } else {
          this.meta = {}
          this.breeder = {}
        }
      }
     
    }
  },
  methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.emitToParent(this.state)
          this.show1 = false
        }
      },
      getBreeder(){
          this.$http.post("breeder/get", {id: this.breeder_id}).then(response => {
            response.data.status? this.breeder = response.data.breeder:this.breeder={} 
            this.meta = this.breeder.meta
        }).catch(e => {
          console.log(e)
        })
      },
    emitToParent (action) {
      this.breeder.meta = this.meta
      this.$emit('DialogEvent', {action: action, breeder:this.breeder})
    }

  }
}
</script>
